import { render, staticRenderFns } from "./CardTrackings.vue?vue&type=template&id=2aae6924&"
import script from "./CardTrackings.vue?vue&type=script&lang=js&"
export * from "./CardTrackings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports